import React, { useEffect } from 'react';
import { Modal } from '@app/src/common/Modal';
import {
  ModalBody,
  Title,
  ButtonActive,
  LoaderWrapper
} from './styled';
import { COLORS } from '@app/src/ui';
import { Icon } from '@app/src/common/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountHash, fetchAccountActive } from '@app/src/common/session';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

interface Props {
  showModal?: boolean;
  closeModal?: Function;
}

export const ModalAccountActivation: React.FC<Props> = ({
  showModal,
  closeModal
}) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.session.account.isFetching);
  const isError = useSelector(state => state.session.account.error);
  const isErrorPOST = useSelector(state => state.session.autentication.errorPOST);
  const messagePOST = useSelector(state => state.session.autentication.dataPOST.message);
  const isLoadingSendData = useSelector(state => state.session.autentication.isFetchingPOST);
  const dataAccount = useSelector(state => state.session.account.data);
  let query = null;
  let currentHash = null;

  useEffect(() => {
    if (isClient && 'URLSearchParams' in window) {
      query = new URLSearchParams(location.search);
      currentHash = query.get('hash');
    }
    if (currentHash) {
      dispatch(fetchAccountHash({
        hash: currentHash
      }));
    }
  }, []);

  const handleClickReactive = () => {
    if (dataAccount && dataAccount.email) {
      dispatch(fetchAccountActive({ email: dataAccount.email }));
    }
  };

  return (
    <Modal show={showModal} closeModal={closeModal}>
      <ModalBody>
        {
          (isLoading || isLoadingSendData) ?
            <LoaderWrapper>
              <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
            </LoaderWrapper>
            :
            <React.Fragment>
              {
                !isError ?
                  <p>Tu cuenta ha sido activada correctamente.</p>
                  :
                  <React.Fragment>
                    {
                      (!isErrorPOST && messagePOST) ?
                        <React.Fragment>
                          <Title>Se ha creado tu cuenta en Clasificados.pe</Title>
                          <p>Se ha generado un nuevo código de activación. Revise su correo.</p>
                        </React.Fragment>
                        :
                        (dataAccount && dataAccount.email) ?
                          <React.Fragment>
                            <p>El código para activar tu cuenta ha expirado.</p>
                            <ButtonActive
                              handleClick={handleClickReactive}
                              color="#fff"
                              background={COLORS.BLACK}
                              width={280}
                            >Generar código de Activación</ButtonActive>
                          </React.Fragment>
                          :
                          <p>Formato no permitido</p>
                    }
                  </React.Fragment>
              }
            </React.Fragment>
        }
      </ModalBody>
    </Modal>
  )
};
